// extracted by mini-css-extract-plugin
export var modal_content = "modalAd-module--modal_content--UaCAC";
export var content = "modalAd-module--content--VKXxv";
export var boldText = "modalAd-module--boldText--9ZrIR";